import {
  Box,
  Button,
  Container,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  OutlinedInput,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";
import DateRangeIcon from "@material-ui/icons/DateRange";
import HomeIcon from "@material-ui/icons/Home";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import "./SearchHeading.css";
import { Link } from "react-router-dom";

const useStyles = makeStyles({});

const SearchHeading = () => {
  const classes = useStyles();
  return (
    <div className="search" style={{ paddingTop: "80px" }}>
      <Container>
        <Box className="side_title">
          <Typography variant="h2">Simplified Freights</Typography>
        </Box>
        <div className="searchContainer">
          <div className="searchHeading">
            <Box className="">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                {/* <Typography variant="span">
                <SearchIcon />
              </Typography> */}
                <InputLabel
                  htmlFor="outlined-adornment-password"
                  className="firstLabel"
                >
                  From
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  value={""}
                  endAdornment={
                    <InputAdornment position="start">
                      <LocationOnOutlinedIcon />
                    </InputAdornment>
                  }
                  labelWidth={60}
                />
              </FormControl>
            </Box>
            <Box className="">
              <FormControl
                className={(classes.margin, classes.textField)}
                variant="outlined"
              >
                {/* <Typography variant="span">
                <SearchIcon />
              </Typography> */}
                <InputLabel
                  htmlFor="outlined-adornment-password"
                  className="firstLabel"
                >
                  To
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  value={""}
                  endAdornment={
                    <InputAdornment position="start">
                      <LocationOnOutlinedIcon />
                    </InputAdornment>
                  }
                  labelWidth={60}
                />
              </FormControl>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box>
                <TextField
                  id="standard-helperText"
                  label="Transportation Type"
                  defaultValue="FTL"
                />
              </Box>
            </Box>
            <Box className="searchText">
              <button className="booking_search_btn">
                {" "}
                <Link to="">
                  <SearchIcon />
                </Link>
              </button>
            </Box>
          </div>
          <div className="headingSearch">
            <Box className="inputIcon">
              <Box>
                <DateRangeIcon />
              </Box>
              <Box>
                <TextField
                  id="standard-helperText"
                  label="Loading Date"
                  defaultValue="Add date for loading the product"
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <HomeIcon />
              </Box>
              <Box>
                <TextField
                  id="standard-helperText"
                  label="Product Type"
                  defaultValue="Foods"
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box>
                <TextField
                  id="standard-helperText"
                  label="Container/Truck Type"
                  defaultValue="Tanker"
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box>
                <TextField
                  id="standard-helperText"
                  label="Weight, MT"
                  defaultValue="20,000 MT"
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box>
                <TextField
                  id="standard-helperText"
                  label="Volume (m3)"
                  defaultValue="45"
                />
              </Box>
            </Box>
            <Box className="borderRight"></Box>
            <Box className="inputIcon">
              <Box>
                <ControlCameraIcon />
              </Box>
              <Box>
                <TextField
                  id="standard-helperText"
                  label="Equipments"
                  defaultValue="Palletjack , Load Straps"
                />
              </Box>
            </Box>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SearchHeading;
